<template>
  <div class="container">
    <div class = "has-text-centered	m-5 p-5">
      <h1 class = "title is-1 has-text-weight-bold">404</h1>
      <p>Nothing was found....</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
